import DataCache from 'utils/cache'

export const dataCache = new DataCache()

export function saveInCache(page, data) {
    const dataCopy = { ...data }
    // strip messages from cached data so they won't reappear after dismissing
    dataCopy['messages'] = []
    dataCache.put(page, dataCopy)
}

/**
 * Seeds the dataCache with pages preloaded server-side (initialState.prefetched_pages,
 * e.g. the marketplace listing embedded on the dashboard) so the first navigation to
 * them is served without a fetch. Integrations are also copied into the store state
 * as a fallback for when the cache TTL expires.
 * @param initialState - the window.appData object; mutated in place
 */
export function seedPrefetchedPages(initialState) {
    if (!initialState.prefetched_pages) {
        return
    }

    Object.entries(initialState.prefetched_pages).forEach(([page, data]) => {
        saveInCache(page, data)

        if (data.integrations && !initialState.integrations) {
            initialState.integrations = data.integrations
        }
    })

    delete initialState.prefetched_pages
}

/**
 * Updates react data cache with the current store state if updateStoreCache is specified in the action
 * @param store
 * @returns {function(*): function(*=): *}
 */
export const cacheUpdater = (store) => (next) => (action) => {
    let result = next(action)
    if (action.updateStoreCache) {
        const state = store.getState()
        saveInCache(location.pathname, state)
    }
    return result
}
